module.exports = __webpack_public_path__ + "static/media/ring-line-1-top.6784eb59.svg";